import { render, staticRenderFns } from "./commentaire-utilisateur.vue?vue&type=template&id=d7427674"
import script from "./commentaire-utilisateur.vue?vue&type=script&lang=ts"
export * from "./commentaire-utilisateur.vue?vue&type=script&lang=ts"
import style0 from "./commentaire-utilisateur.vue?vue&type=style&index=0&id=d7427674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports